import React from 'react'

import Button from '../Button'

import share from 'lib/shared'

import './result.css'
import classes from './styles'

const resultTexts = [
  //0-20 ошибок
  'Кажется, вы прогуливали в школе уроки русского языка.',

  // 21-50 ошибок
  'Время внимательно перечитать Розенталя.',

  // 51-80 ошибок
  'Вы точно не перепутаете -тся и -ться. Так держать.',

  //81-100 ошибок
  'Да вы настоящий grammar nazi!',
]

class Result extends React.Component {
  constructor(props) {
    super(props)

    window.ga('send', 'event', 'Показы', 'Экран', 'Финальный экран_Редактор')
  }

  render() {
    const { currentPostIndex, rightAnswerCount } = this.props

    const shareMessage = `Успел вычитать ${currentPostIndex} текстов, нашел ${rightAnswerCount} ошибок.`;
    const reset = () => {
      window.ga('send', 'event', 'Переходы', 'Повторное прохождение', 'editor')
      location.href = 'https://10years.lifehacker.ru/editor/'
    }
    const resultText = (() => {
      if (rightAnswerCount < 21) return resultTexts[0]
      if (rightAnswerCount < 51) return resultTexts[1]
      if (rightAnswerCount < 81) return resultTexts[2]
      return resultTexts[3]
    })()

    return (
      <div className={classes.resultWrapper}>
        <div className={[classes.result, 'result'].join(' ')}>
          <h3>
            {resultText}
          </h3>

          <div className="result__counts">
            <div className="result__count">
              <div className="result__count__label">Вычитано текстов:</div>
              <div className="result__count__value">10</div>
            </div>
            <div className="result__count">
              <div className="result__count__label">Найдено ошибок:</div>
              <div className="result__count__value">{rightAnswerCount}</div>
            </div>
          </div>

          <div className={classes.buttonBlock}>
            <Button
              onClick={reset}
            >
              Ещё раз
            </Button>
          </div>


          <div className={classes.sharedBlock}>
            <div className={classes.sharingTitle}>
              Рассказать друзьям:
            </div>

            <div>
              <img
                onClick={() => share.vk(shareMessage)}
                className={classes.share}
                src='https://10years.lifehacker.ru/static/images/vk_button.svg'
                alt=""
              />

              <img
                onClick={() => share.fb(shareMessage)}
                className={classes.share}
                src='https://10years.lifehacker.ru/static/images/fb_button.svg'
                alt=""
              />

              <img
                onClick={() => share.tw(shareMessage)}
                className={classes.share}
                src='https://10years.lifehacker.ru/static/images/tw_button.svg'
                alt=""
              />
            </div>
          </div>

        </div>
      </div>
    )
  }
}

Result.propTypes = { }

export default Result


// WEBPACK FOOTER //
// ./src/components/Result/Result.jsx